import type {DecorationPlugin} from '../../types'
import {pack} from './pack'

export const sortPlugin = {
    name: 'SortPlugin',
    pack
} satisfies DecorationPlugin
